// extracted by mini-css-extract-plugin
export default {"verifiedSection":"VerifiedSection_verifiedSection__lAQ1+","cardContainer":"VerifiedSection_cardContainer__4oEw3","particles":"VerifiedSection_particles__dVKvh"};